import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as PagesActions from "../../actions/pagesActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";
import asyncForEach from "../../helpers/objectManipulation/asyncForEach";

const loadPagesLogic = createLogic({
	type: ActionTypes.LOAD_PAGES,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/experiences/${action.expId}/pages`)
					.then(async res => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(PagesActions.loadPagesSuccess(res.data));
						const chatPages = res.data.filter(
							page => page.moduleKey === "@hillsong-technology/verris-module-chat"
						);
						const pollingPages = res.data.filter(page => page.moduleKey === "@brushfire/polls");
						// Handle chat pages
						if (chatPages.length > 0) {
							const chatPayload = {};
							await asyncForEach(chatPages, async page => {
								const pageConfig = await api.get(`/pages/${page.id}`);
								if (pageConfig.status === 200) {
									chatPayload[page.id] = pageConfig.data;
								}
							});
							dispatch(PagesActions.setChatPages(chatPayload));
						}
						// Handle polling pages
						if (pollingPages.length > 0) {
							const pollingPayload = {};
							await asyncForEach(pollingPages, async page => {
								const pageConfig = await api.get(`/pages/${page.id}`);
								if (pageConfig.status === 200) {
									pollingPayload[page.id] = pageConfig.data;
								}
							});
							dispatch(PagesActions.setPollingPages(pollingPayload));
						}
						done();
					})
					.catch(error => {
						console.log(">>>> error: ", JSON.stringify(error));
						dispatch(ControlPanelActions.hideLoading());
						dispatch(PagesActions.loadPagesFail(error));
						done();
					});
			});
	},
});

export default [loadPagesLogic];
